import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {startSteamAuthFlow} from 'app/utils/steamLink';
import logEvent from 'app/amplitude/log_event';
import {pushAnalyticsEvent} from 'app/utils/analytics';

interface Props {
    redirectUrl?: string;
    usingOnTab?: string;
    getPromocode?: () => string | undefined;
}

export default class FastRegistrationSingWithSteam extends PureComponent<Props> {
    handleClick = (): void => {
        const {redirectUrl, usingOnTab, getPromocode} = this.props;

        logEvent('JOIN_PAGE_LEAD', {
            SOURCE: usingOnTab,
            method: 'steam'
        });
        pushAnalyticsEvent('registration_start', {
            method: 'steam',
            placement: usingOnTab || 'registration_popup'
        });

        startSteamAuthFlow({
            promocode: getPromocode?.(),
            redirectUrl
        });
    };

    render(): ReactNode {
        return (
            <div className="registration-sign-with">
                <div className="registration-sign-with__title">
                    <span>{I18n.t('sign_in_with')}</span>
                </div>
                <ul className="registration-sign-with__list">
                    <li>
                        <button
                            type="button"
                            className="button-sign-with"
                            onClick={this.handleClick}
                        >
                            <SpriteIcon name="#svg-steam-icon" className="svg-default" />
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}
